module.exports = __webpack_public_path__ + "static/media/hero.5f000b51.png";